<template>
  <UModal v-model:open="videoState.isOpen" width="sm:max-w-md">
    <template #header>
      <div class="flex items-center justify-between w-full">
        <h3>
          {{ videoState.title }}
        </h3>
        <UButton icon="i-lucide:x" variant="ghost" @click="closeVideo" />
      </div>
    </template>
    <template #body>
      <div class="py-2">
        <iframe
          v-if="embedVideoUrl"
          :src="embedVideoUrl"
          width="100%"
          height="315"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </template>
    <template #footer>
      <div class="flex justify-center gap-3 w-full">
        <UButton icon="i-lucide-youtube" @click="showVideo"> Assistir no Youtube </UButton>
      </div>
    </template>
  </UModal>
</template>

<script setup lang="ts">
const embedVideoUrl = computed(() => {
  if (!videoState.value.videoUrl) return '';

  try {
    const parsedUrl = new URL(videoState.value.videoUrl);
    const hostname = parsedUrl.hostname.replace(/^www\./, '');

    if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
      const videoId = parsedUrl.searchParams.get('v');
      if (videoId) return `https://www.youtube.com/embed/${videoId}`;

      const pathParts = parsedUrl.pathname.split('/').filter(Boolean);
      if (pathParts[0] === 'shorts' && pathParts[1]) {
        return `https://www.youtube.com/embed/${pathParts[1]}`;
      }
    }

    if (hostname === 'youtu.be') {
      const videoId = parsedUrl.pathname.split('/').filter(Boolean)[0];
      if (videoId) return `https://www.youtube.com/embed/${videoId}`;
    }

    return videoState.value.videoUrl;
  } catch {
    return videoState.value.videoUrl;
  }
});

const { state: videoState, closeVideo } = useVideo();
function showVideo() {
  if (videoState.value.videoUrl) {
    window.open(videoState.value.videoUrl, '_blank');
  } else {
    alert('No tutorial video available for this page.');
  }
}
</script>
